import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../../i18n/hooks';
import { useAuth } from '../hooks';
import { PageContainer, ArbiWinHeader, ArbiWinFooter, MainContainer } from '../../ui';
import ChangePasswordForm from './ChangePasswordForm';
import './ChangePasswordPage.css';

/**
 * ChangePasswordPage - Separate page for changing password
 * @returns {JSX.Element} ChangePasswordPage component
 */
const ChangePasswordPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isAuthenticated, logout, user } = useAuth();

  const handleSuccess = () => {
    // Navigate back to profile after successful password change
    navigate('/profile');
  };

  const handleCancel = () => {
    // Navigate back to profile when user cancels
    navigate('/profile');
  };

  const handleHomeClick = () => {
    navigate('/');
  };

  const handleLogin = () => {
    navigate('/login');
  };

  const handleRegister = () => {
    navigate('/register');
  };

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/');
    } catch (error) {
      console.error('Logout error:', error);
      // Still navigate to home even if logout fails
      navigate('/');
    }
  };

  return (
    <PageContainer>
      <ArbiWinHeader
        isAuthenticated={isAuthenticated}
        user={user}
        onHomeClick={handleHomeClick}
        onLogin={handleLogin}
        onRegister={handleRegister}
        onLogout={handleLogout}
      />
      
      <MainContainer>
        <div className="change-password-page">
          <div className="change-password-page-content">
            <ChangePasswordForm
              onSuccess={handleSuccess}
              onCancel={handleCancel}
            />
          </div>
        </div>
      </MainContainer>
      
      <ArbiWinFooter />
    </PageContainer>
  );
};

export default ChangePasswordPage;
